<template>
  <div class="recent-content">
    <h3 class="typo-headline-6">Contenido Reciente</h3>
    <ul v-if="recentTopics.length">
      <recent-content-topic
        v-for="topic in recentTopics"
        :key="topic.nid"
        :topic="topic"
      />
    </ul>
    <p v-else class="typo-body-2">Cargando contenido reciente...</p>
    
    <!--<div class="view-all-link">
      <router-link to="/forum" class="typo-button">
        Ver todo el contenido
      </router-link>
    </div>-->
  </div>
</template>

<script>
import forumApi from '@/services/forumApi';
const axios = forumApi;
import RecentContentTopic from './RecentContentTopic.vue';

export default {
  name: 'RecentContentContainer',
  components: {
    RecentContentTopic
  },
  data() {
    return {
      recentTopics: [],
      loading: true,
      error: null
    };
  },
  mounted() {
    this.fetchRecentContent();
  },
  methods: {
    fetchRecentContent() {
      axios
        .get('/forum/contenido-reciente?limit=10')
        .then(response => {
          this.recentTopics = response.data?.items || [];
        })
        .catch(err => {
          console.error('Error fetching recent content:', err);
          this.recentTopics = [];
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.recent-content {
  background-color: var(--color-surface);
  padding: 20px;
  border-radius: 15px;
  color: var(--color-text-primary);
}

.recent-content h3 {
  margin-top: 0;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--color-outline);
}

/* List Reset */
ul {
  padding: 0;
  margin: 0;
}

.view-all-link {
  margin-top: 15px;
  text-align: center;
}

.view-all-link a {
  display: inline-block;
  color: var(--color-highlight);
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.view-all-link a:hover {
  background-color: var(--color-active-surface);
}
</style> 